import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { PilotContactForm } from "./PilotContactForm";

// Design tokens for dark modal background
const colors = {
  white: "#FFFFFF",         // Primary text on dark bg
  whiteSecondary: "rgba(255, 255, 255, 0.7)",  // Secondary text on dark bg
};

interface PilotContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (email: string) => void;
}

export const PilotContactModal: React.FC<PilotContactModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[540px] p-0 overflow-hidden max-h-[90vh]">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle
            className="text-2xl font-semibold"
            style={{ color: colors.white }}
          >
            Join Our Pilot Program
          </DialogTitle>
          <DialogDescription
            className="text-sm leading-relaxed"
            style={{ color: colors.whiteSecondary }}
          >
            TerraMatrix is currently in a closed pilot program. We're selecting
            partners who can help shape the future of AI-powered IoT management.
            Tell us about your business and how we can help.
          </DialogDescription>
        </DialogHeader>

        <div className="px-6 pb-10 overflow-y-auto max-h-[calc(90vh-120px)]">
          <PilotContactForm
            onSuccess={onSuccess}
            onCancel={onClose}
            showCancelButton={true}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
